var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRedArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2279_17259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0063 19.3532L15.0063 21.3893L21.0076 21.39L21.0076 15.2804L19.0072 15.2811L19.0064 17.9126L13.677 12.4862L12.2628 13.9261L17.5922 19.3525L15.0063 19.3532Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.971 28.4788C23.0465 28.4788 27.9707 23.465 27.9707 17.2791C27.9707 11.0931 23.0465 6.0793 16.971 6.0793C10.8955 6.0793 5.97124 11.0931 5.97124 17.2791C5.97124 23.465 10.8955 28.4788 16.971 28.4788ZM16.971 26.4427C19.358 26.4427 21.6472 25.4773 23.335 23.7588C25.0228 22.0402 25.971 19.7094 25.971 17.2791C25.971 14.8487 25.0228 12.5179 23.335 10.7993C21.6472 9.08082 19.358 8.11536 16.971 8.11536C14.584 8.11536 12.2948 9.08082 10.607 10.7993C8.91916 12.5179 7.97094 14.8487 7.97094 17.2791C7.97094 19.7094 8.91916 22.0402 10.607 23.7588C12.2948 25.4773 14.584 26.4427 16.971 26.4427Z",
    fill: "#FF0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2279_17259"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.2192,
    height: 24.2192,
    fill: "white",
    transform: "matrix(-0.700708 0.713448 -0.700708 -0.713448 33.9414 17.2791)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedArrow);
export default __webpack_public_path__ + "static/media/red-arrow.41acc1b9edb472baa8eb7a39e75abeb6.svg";
export { ForwardRef as ReactComponent };